import type { IconSvgObject } from './types';

const LineDotRightHorizontalIcon: IconSvgObject = [
  ["circle", { cx: "17.9961", cy: "12", r: "4", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.9961 12H1.99609", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LineDotRightHorizontalIcon;
